import styled from 'styled-components';

export const AccordionContainer = styled.div`
  border: 1px solid var(--line);
  border-radius: var(--r-md);
  width: 100%;
`;

export const AccordionHeader = styled.div<{ isOpen: boolean }>`
  background-color: var(--paper);
  color: var(--ink);
  padding: var(--s-4);
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: var(--weight-medium);
`;

export const AccordionContent = styled.div<{ isOpen: boolean }>`
  overflow: hidden;
  background-color: var(--surface);
  opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
  transition: opacity 0.4s ease, max-height 0.4s ease;
  > div {
    padding: var(--s-4);
  }
`;

export const AccordionIcon = styled.span<{ isOpen: boolean }>`
  transform: rotate(${({ isOpen }) => (isOpen ? '180deg' : '0')});
  transition: transform 0.3s ease;
`;
